import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import VM from 'scratch-vm';
import AudioEngine from 'scratch-audio';

import { setProjectUnchanged } from '../reducers/project-changed';

import {
    tabsActive
} from '../reducers/editor-tab';

import {
    setActiveId
} from '../reducers/targets';

import ScratchBlock from 'scratch-blocks';

import {
    LoadingStates,
    getIsLoadingWithId,
    onLoadedProject,
    projectError
} from '../reducers/project-state';

if (window.require != undefined) {
    var ipcRenderer = window.require('electron').ipcRenderer;
}

/*
 * Higher Order Component to manage events emitted by the VM
 * @param {React.Component} WrappedComponent component to manage VM events for
 * @returns {React.Component} connected component with vm events bound to redux
 */
window.detectionUpdateNum = 0;
var SoftwareOne = 0

const vmManagerHOC = function (WrappedComponent) {
    class VMManager extends React.Component {
        constructor(props) {
            super(props);
            bindAll(this, [
                'loadProject'
            ]);
        }
        componentDidMount() {
            if (!this.props.vm.initialized) {
                this.audioEngine = new AudioEngine();
                this.props.vm.attachAudioEngine(this.audioEngine);
                this.props.vm.setCompatibilityMode(true);
                this.props.vm.initialized = true;
            }
            if (!this.props.isPlayerOnly && !this.props.isStarted) {
                this.props.vm.start();
            }
        }
        componentDidUpdate(prevProps) {
            // if project is in loading state, AND fonts are loaded,
            // and they weren't both that way until now... load project!
            if (this.props.isLoadingWithId && this.props.fontsLoaded &&
                (!prevProps.isLoadingWithId || !prevProps.fontsLoaded)) {
                this.loadProject();
            }
            // Start the VM if entering editor mode with an unstarted vm
            if (!this.props.isPlayerOnly && !this.props.isStarted) {
                this.props.vm.start();
            }
        }
        loadProject() {
            var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null;
            if (is_mobi) {
                ScratchBlock.setMobi(true)
            } else {
                ScratchBlock.setMobi(false)
            }
            return this.props.vm.loadProject(this.props.projectData)
                .then(() => {
                    this.props.onLoadedProject(this.props.loadingState, this.props.canSave);
                    // Wrap in a setTimeout because skin loading in
                    // the renderer can be async.
                    setTimeout(() => this.props.onSetProjectUnchanged());

                    const robots = this.props.vm.runtime.targets.filter(target => target.isRobot)
                    this.props.vm.setRobotType(robots[0].robotType)
                    // If the vm is not running, call draw on the renderer manually
                    // This draws the state of the loaded project with no blocks running
                    // which closely matches the 2.0 behavior, except for monitors–
                    // 2.0 runs monitors and shows updates (e.g. timer monitor)
                    // before the VM starts running other hat blocks.
                    if (!this.props.isStarted) {
                        // Wrap in a setTimeout because skin loading in
                        // the renderer can be async.
                        setTimeout(() => this.props.vm.renderer.draw());

                    }
                    this.props.onSetActiveId(this.props.vm.editingTarget.id)


                    //检测软件版本onSetUpdataTime
                    if (window.detectionUpdateNum == 0) {
                        window.detectionUpdateNum = 1
                        ipcRenderer && ipcRenderer.send('udp_cmd', 'GEN_APPLICATION_UPDATE')
                        ipcRenderer && ipcRenderer.on('version-update', (event, arg) => {
                            console.log('控制器发来的查询软件版本信息version-update：', arg)
                            if (arg.command == 'UPDATE') {
                                window.__yourReactComp__.setState({
                                    softwareVersion: {
                                        current: arg.current,
                                        lastest: arg.lastest
                                    },
                                    updateProgress: 6,
                                    isUpdateBox: true

                                });
                            } else if (arg.command == 'LATEST VERSION') {
                                if (SoftwareOne == 1) {
                                    window.__yourReactComp__.setState({
                                        softwareVersion: {
                                            current: arg.current,
                                            lastest: arg.lastest
                                        },
                                        updateProgress: 7,
                                        isUpdateBox: true
                                    });
                                } else {
                                    SoftwareOne = 1
                                }
                            }
                        })
                        // 检测机器固件版本更新
                        ipcRenderer && ipcRenderer.on('firmware-update', (event, arg) => {
                            switch (true) {
                                case arg.value == '2':
                                    if (arg.command == 'UPDATE') {
                                        console.log('监听到固件版本需要更新的通知firmware-update')
                                        if (window.__yourReactComp__.state.isMenuClick) {
                                            console.log('我点击了固件升级按钮')
                                            window.__yourReactComp__.setState({
                                                hasUpdate: true, //显示红点提示有新的固件更新 
                                                updateProgress: 1,
                                                isUpdateBox: true,
                                                version: {
                                                    current: arg.current,
                                                    lastest: arg.lastest
                                                },
                                                isMenuClick: false
                                            });
                                        } else {
                                            window.__yourReactComp__.setState({
                                                //bubble: true, //显示固件更新提示气泡 
                                                hasUpdate: true, //显示红点提示有新的固件更新 
                                                updateProgress: 1,
                                                isUpdateBox: true,
                                                version: {
                                                    current: arg.current,
                                                    lastest: arg.lastest
                                                },
                                                isMenuClick: false
                                            });
                                        }
                                    } else if (arg.command == 'LASTEST') {
                                        if (window.__yourReactComp__.state.isMenuClick) {
                                            window.__yourReactComp__.setState({
                                                updateProgress: 8,
                                                isUpdateBox: true,
                                                version: {
                                                    current: arg.current,
                                                    lastest: arg.lastest
                                                },
                                                isMenuClick: false
                                            });
                                        } else {
                                            window.__yourReactComp__.setState({
                                                updateProgress: 1,
                                                version: {
                                                    current: arg.current,
                                                    lastest: arg.lastest
                                                }
                                            });
                                        }
                                    }
                                    break;
                                case arg.value == '3':
                                    window.updateProps.setState({
                                        current: 1,
                                        check: "wait",
                                        status: "process",
                                        updatePage: 1,
                                    })
                                    //alert("正在下载")
                                    break;
                                case arg.value == '4':
                                    window.updateProps.setState({
                                        current: 2,
                                        check: "wait",
                                        status: "process",
                                        updatePage: 2,
                                        // rate: json.progress
                                    })
                                    //alert("正在拷贝文件到控制器")
                                    break;
                                case arg.value == '1':

                                    window.__yourReactComp__.setState({
                                        hasUpdate: false //如果有小红点则去掉红点显示
                                    });
                                    window.updateProps.setState({
                                        current: 2,
                                        check: "wait",
                                        status: "process",
                                        updatePage: 3
                                    })
                                    // updateNum = 0
                                    //alert("安装成功")
                                    break;
                                default:
                                    window.__yourReactComp__.setState({
                                        //     isUpdateBox: false, //关闭更新窗口
                                        hasUpdate: true //如果有小红点则去掉红点显示
                                    });
                                    window.updateProps.setState({
                                        check: "error",
                                        status: "error",
                                        updatePage: 404,
                                        errorMessage: arg.value
                                    })
                                    break;
                            }
                        })

                    }




                })
                .catch(e => {
                    this.props.onError(e);
                });
        }
        render() {
            const {
                /* eslint-disable no-unused-vars */
                fontsLoaded,
                loadingState,
                isStarted,
                onError: onErrorProp,
                onLoadedProject: onLoadedProjectProp,
                onSetProjectUnchanged,
                projectData,
                /* eslint-enable no-unused-vars */
                isLoadingWithId: isLoadingWithIdProp,
                vm,
                ...componentProps
            } = this.props;
            return (
                <WrappedComponent
                    isLoading={isLoadingWithIdProp}
                    vm={vm}
                    {...componentProps}
                />
            );
        }
    }

    VMManager.propTypes = {
        canSave: PropTypes.bool,
        cloudHost: PropTypes.string,
        fontsLoaded: PropTypes.bool,
        isLoadingWithId: PropTypes.bool,
        isPlayerOnly: PropTypes.bool,
        loadingState: PropTypes.oneOf(LoadingStates),
        onError: PropTypes.func,
        onLoadedProject: PropTypes.func,
        onSetProjectUnchanged: PropTypes.func,
        projectData: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
        projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        username: PropTypes.string,
        vm: PropTypes.instanceOf(VM).isRequired
    };

    const mapStateToProps = state => {
        const loadingState = state.scratchGui.projectState.loadingState;
        return {
            fontsLoaded: state.scratchGui.fontsLoaded,
            isLoadingWithId: getIsLoadingWithId(loadingState),
            projectData: state.scratchGui.projectState.projectData,
            projectId: state.scratchGui.projectState.projectId,
            loadingState: loadingState,
            isPlayerOnly: state.scratchGui.mode.isPlayerOnly,
            isStarted: state.scratchGui.vmStatus.started
        };
    };

    const mapDispatchToProps = dispatch => ({
        onError: error => dispatch(projectError(error)),
        onLoadedProject: (loadingState, canSave) => {
            dispatch(tabsActive(0))
            dispatch(onLoadedProject(loadingState, canSave, true))
        },
        onSetProjectUnchanged: () => dispatch(setProjectUnchanged()),
        onSetActiveId: (id) => {
            dispatch(setActiveId(id))
        }
    });

    // Allow incoming props to override redux-provided props. Used to mock in tests.
    const mergeProps = (stateProps, dispatchProps, ownProps) => Object.assign(
        {}, stateProps, dispatchProps, ownProps
    );

    return connect(
        mapStateToProps,
        mapDispatchToProps,
        mergeProps
    )(VMManager);
};

export default vmManagerHOC;
